import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      locale: (state) => state.preference.locale,
      defaultLocale: (state) => state.preference.defaultLocale
    }),
  },

  methods: {
    translate(value) {
      if (typeof value !== 'object') {
        throw "value to translate has to be an object";
      }

      let val = value[this.locale];
      if (val === undefined || val === null) {
        // Check default locale
        val = value[this.defaultLocale];
      }

      if (val === undefined || val === null) {
        throw "translate failed, value doesnt have the required locale: " + this.locale;
      }

      return val;
    },
      dutchTranslation(value) {
          if (typeof value !== 'object') {
              throw "value to translate has to be an object";
          }

          let val = value['nl'];

          if (val === undefined || val === null) {
              throw "translate failed, value doesnt have the dutch locale";
          }

          return val;
      }
  }
}
